import React from 'react';
import moment from 'moment';

export default class NoteRow extends React.Component {
  render() {
    const {RowData} = this.props
    
    return (
			<div className="card no-margin divider-horizontal" key={RowData.Alias}>
				<div className="card-block-special">
					<div className="flex">
						<strong>{RowData.Owner.FirstName}&nbsp;{RowData.Owner.LastName}</strong><span className="mrml-6 color-visible">created note</span><span style={{maxWidth:'80%'}} className="title-note-list break-word">{RowData.Name}</span>
					</div>
					<div>
						<p className="m-botom-6 break-word">
              {RowData.Description} <span className="representation"> · </span>
              <span className="color-visible fs-12">{moment(RowData.CreatedTime).fromNow()}</span>
            </p>
					</div>
					<a href="" role="button" onClick={(e)=>this.props.toggleModalComment(e, RowData)}>
            <span>{RowData.CommentCount}&nbsp;Comments</span>
          </a>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Row/NoteRow.js